export default __webpack_public_path__ + "static/media/arrowRight.08eae205.svg";